module.exports = __webpack_public_path__ + "img/040.4055c4c6.jpg";